import React, {useEffect, useState} from 'react';
import RouteTimeCircle from "../RouteTimeCircle/RouteTimeCircle";
import "./style.scss";
import {secondsUntil} from "../../Utils/TimeUtils";
import _ from "lodash";
import {MenuItem, Select} from "@material-ui/core";
import moment from "moment";
import useInterval from "../Utils/UseInterval";

export default function SentRouteMetadata({route, users, additionalMessengerId, isEdit, onChangeMessenger}) {
    const [messengerUser, setMessengerUser] = useState(null);
    const [availableMessengers, setAvailableMessengers] = useState([]);
    const [lastActionSubtitleText, setLastActionSubtitleText] = useState(null);

    useEffect(() => {
        if (users) {
            const filteredMessengers = users.filter(messenger =>
                _.get(messenger, "profiles.messenger.isCurrentlyAvailable") || messenger.id === additionalMessengerId);

            setAvailableMessengers(filteredMessengers);
        } else {
            setAvailableMessengers([]);
        }
    }, [users]);

    function updateLastActionSubtitle() {
        switch (route.status) {
            case "ASSIGNED":
                const assignedFromNow = moment(route.timestamp).fromNow(true);
                setLastActionSubtitleText(`שובץ לפני ${assignedFromNow}`);
                return;
            case "ACCEPTED":
                const collectedTime = route.route[0].order.collectedTime;
                const collectedFromNow = moment(collectedTime).fromNow(true);
                setLastActionSubtitleText(`אסף לפני ${collectedFromNow}`);
                return;
            case "EDIT":
                setLastActionSubtitleText('ייצא עכשיו');
                return;
        }
    }

    useInterval(() => {
        if (route) {
            updateLastActionSubtitle();
        }
    }, 5000);

    useEffect(() => {
        if (route) {
            setMessengerUser(users.find(user => user.id === route.messenger_id));
            updateLastActionSubtitle();
        } else {
            setMessengerUser(null);
        }
    }, [route]);

    function onSelectMessenger(e, messengerId) {
        if (onChangeMessenger && messengerId !== messengerUser.id) {
            onChangeMessenger(messengerId);
        }
    }

    function getHumanizedExpectedPickupTime() {
        const seconds = secondsUntil(route.expected_pickup)

        const prefix_word = seconds >= 0 ? "בעוד" : "לפני";

        return prefix_word + " " + moment.duration(seconds, 'seconds').humanize()
    }

    if (!route)
        return null;

    const finishTime = new Date(route.real_time_finish_time ?
        route.real_time_finish_time :
        new Date(route.timestamp).getTime() + route.duration * 1000)

    return (
        <div className="route-metadata">
            <div className="courier-info">
                {
                    !messengerUser ?
                        null
                        :
                        (
                            !isEdit ?
                                <div className="courier-name-container">
                                    <div className="courier-name">
                                        {messengerUser.name}
                                    </div>
                                </div>
                                :
                                <Select
                                    onChange={(e) => onSelectMessenger(e, e.target.value)}
                                    value={messengerUser.id}
                                    className="messenger-select">
                                    {
                                        availableMessengers.map((messenger, index) =>
                                            <MenuItem
                                                key={`active-group-messenger-${messenger.id}`}
                                                value={messenger.id}>{messenger.name}</MenuItem>
                                        )
                                    }
                                </Select>
                        )
                }
                <div className="last-action-subtitle">
                    {lastActionSubtitleText || '\u00A0'}
                </div>
                {
                    route.yango_claim_id ?
                        <div className="yango-claim-id-subtitle-container">
                            <div className="yango-claim-id">
                                <span>מזהה Yango:&nbsp;</span>
                                <span>{route.yango_claim_id}</span>
                            </div>
                            {
                                messengerUser?.phoneNumber ?
                                    <div className="yango-courier-phone-number">
                                        <span>מספר טלפון שליח: {messengerUser?.phoneNumber}, שלוחה: {messengerUser?.phoneExtension}</span>
                                    </div>
                                    :
                                    null
                            }
                            {
                                route.status === "ASSIGNED" && route.expected_pickup ?
                                    <div className="yango-courier-expected-pickup">
                                        <span>זמן הגעת שליח: {getHumanizedExpectedPickupTime()}</span>
                                    </div>
                                    :
                                    null
                            }
                        </div>
                        :
                        null
                }
            </div>
            <div className="route-time-circle-wrapper">
                <RouteTimeCircle status={route.status}
                                 totalDuration={route.duration}
                                 durationTillFinish={isEdit ? route.duration : secondsUntil(finishTime)}/>
            </div>
        </div>
    );
}